import { render, staticRenderFns } from "./confirm-recept-modal.vue?vue&type=template&id=68128ab8"
import script from "./confirm-recept-modal.vue?vue&type=script&lang=js"
export * from "./confirm-recept-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports